import React, {useState, useContext, useEffect, useRef} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import {getQuestionarioData, enviarQuestionario} from '../../../pages/requests';
import {ToastContainer} from 'react-toastify';
import {toast} from 'react-toastify';
import Spinner from '../../Spinner';
import SelectComponent from '../../Selects/SelectComponent';
import {useHistory, useParams} from 'react-router-dom';

// import { Container } from './styles';

function NovoQuestionario({questionarioSelecionado, setShowForm, loading, setLoading, guardarQuestionario, setGuardarQuestionario}) {
    const [perguntas, setPerguntas] = useState([]);
    const {openCards, acessos} = useContext(Context);
    const {t} = useTranslation();
    const history = useHistory();

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const permissao = acessos.find(element => element.funcao == 'GESYCONSCON') ?? {
        apagar: false,
        consultar: false,
        criar: false,
        funcao: 'GESYCONSCON',
        modificar: false,
    };

    const handleRangeChange = (e, dados) => {
        dados.valor = e.target.value;
        dados.alterada = true;
        setPerguntas(perguntas.map(p => (p.id === dados.id ? dados : p)));
    };

    useEffect(() => {
        debugger;
        if (questionarioSelecionado) {
            setLoading(true);
            getQuestionarioData(questionarioSelecionado.id, lang)
                .then(res => {
                    if (res.data.success) {
                        setPerguntas(
                            res.data.questionario.perguntas.map(p => {
                                return {...p, alterada: false};
                            }),
                        );
                    } else {
                        toast.warn(res.data.erro, {
                            position: 'top-right',
                            autoClose: 6000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: 'light',
                        });
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [questionarioSelecionado]);

    useEffect(() => {
        if (guardarQuestionario) {
            GravarRespostas();
        }
    }, [guardarQuestionario]);

    async function GravarRespostas() {
        // var resposta = perguntas.find(e => e.id == controlo.id && e.linhaId == controlo.linhaId);
        // var perguntas = [];
        // perguntas.push(resposta);

        const bodyParameters = {
            perguntas: perguntas.filter(p => p.alterada),
            id: 'NUM1',
        };

        const guardarConclusaoWS = new Promise((resolve, reject) => {
            enviarQuestionario(bodyParameters, lang)
                .then(function (result) {
                    if (result.data.sucesso == true) {
                        resolve('Sucesso!');
                    } else {
                        let mensagem = result.data.errorMessages;
                        let resposta = '';
                        if (mensagem) resposta = mensagem;
                        if (!mensagem) resposta = t('toastErro');
                        reject(resposta);
                    }
                })
                .catch(() => reject(t('toastErroServidor')));
        });
        toast.promise(
            guardarConclusaoWS,
            {
                success: {
                    render({data}) {
                        // history.push('/Questionarios');
                        setShowForm(false);
                        setGuardarQuestionario(false);
                        return t('questionarioRegistado');
                    },
                },
                pending: t('a_guardar'),
                error: {
                    render({data}) {
                        setGuardarQuestionario(false);
                        return data;
                    },
                },
            },
            {autoClose: 900},
        );
    }

    function guardarResposta(resp, id, linId) {
        let perguntasTemp = [];
        perguntas.forEach(element => {
            if (element.id === id && element.linhaId === linId) {
                element.descricaoRespSel = resp;
                element.alterada = true;
            }
            perguntasTemp.push(element);
        });
        setPerguntas(perguntasTemp);
    }

    function guardarRespostaSelecao(linResp, descResp, id, linId) {
        let perguntasTemp = [];
        perguntas.forEach(element => {
            if (element.id === id && element.linhaId === linId) {
                element.linRespSel = linResp;
                element.descricaoRespSel = descResp;
                element.alterada = true;
            }
            perguntasTemp.push(element);
        });
        setPerguntas(perguntasTemp);
    }

    return (
        <>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {!loading && (
                <div>
                    <div
                        className={`w-full p-2  bg-white border border-gray-200 rounded-[4px] shadow sm:p-8 dark:bg-gray-600 dark:border-gray-700 ${
                            isMobile ? '' : 'grid grid-cols-8 gap-3'
                        }  flex-wrap`}>
                        <div className="flex flex-col col-span-2 flex-wrap">
                            <div className="flex flex-row">
                                {' '}
                                <h5 className="mb-2 text-lg mr-2 font-medium text-gray-900 dark:text-white">{t('cliente')}:</h5>
                                <p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">{questionarioSelecionado.cliente.nomeCliente}</p>
                            </div>
                            <div className="flex flex-row">
                                {' '}
                                <h5 className="mb-2 text-lg mr-2 font-medium text-gray-900 dark:text-white">{t('representante')}:</h5>
                                <p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">{questionarioSelecionado.representante.label}</p>
                            </div>
                        </div>
                        <div className="flex flex-col col-span-4 flex-wrap">
                            <div className="flex flex-row">
                                {' '}
                                <h5 className="mb-2 text-lg mr-2 font-medium text-gray-900 dark:text-white">{t('negocio')}:</h5>
                                <p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">{questionarioSelecionado.negocio.nome}</p>
                            </div>
                        </div>
                        <div className="flex flex-col col-span-2 flex-wrap">
                            <div className="flex flex-row">
                                {' '}
                                <h5 className="mb-2 text-lg mr-2 font-medium text-gray-900 dark:text-white">{t('contacto')}:</h5>
                                <p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">{questionarioSelecionado.negocio.contactos}</p>
                            </div>
                            <div className="flex flex-row">
                                {' '}
                                <h5 className="mb-2 text-lg mr-2 font-medium text-gray-900 dark:text-white">{t('data')}:</h5>
                                <p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">{questionarioSelecionado.dataCriacao}</p>
                            </div>
                        </div>
                        {/* <div className="items-center justify-center space-y-4 sm:flex sm:space-y-0 sm:space-x-4 rtl:space-x-reverse"></div> */}
                    </div>

                    {perguntas?.map((dados, index) => {
                        {
                            if (dados.descricaoRespSel != '' || dados.valor != 0 || dados.observacoes != '') {
                                dados.alterada = true;
                            }
                        }
                        return (
                            <div
                                key={index}
                                className={`${
                                    !dados.alterada
                                        ? 'w-full p-4 mt-4 mb-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-[8px] dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400'
                                        : 'w-full p-4 mt-4 mb-4 text-green-700 bg-green-50 border border-green-300 rounded-[8px] dark:bg-gray-900 dark:border-green-500 dark:text-green-400'
                                } `}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0  px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2]  text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        {index + 1}. {dados.descricao} {dados.alterada ? <CheckRoundedIcon className="ml-2" /> : ''}
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        {/* <div className="flex flex-row items-center flex-wrap"> */}
                                        <span className="text-gray-600 dark:text-gray-400">{t('resposta')}:</span>
                                        {dados.respostas?.length === 1 && dados.respostas[0].tipoControlo !== '1' ? (
                                            <div className="flex w-96 ">
                                                <input
                                                    type={dados.respostas[0]?.tipoResposta === 2 ? 'number' : 'text'}
                                                    min={0}
                                                    value={dados.descricaoRespSel}
                                                    className="block w-full mr-6 text-sm p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                                                    onChange={e => {
                                                        console.log(e.target.value, dados.id, dados.linhaId);
                                                        guardarResposta(e.target.value, dados.id, dados.linhaId);
                                                    }}
                                                    disabled={questionarioSelecionado.validado || !permissao.modificar}
                                                />
                                            </div>
                                        ) : (
                                            <div className="flex mr-6 ">
                                                <SelectComponent
                                                    options={dados.respostas.map(el => ({
                                                        label: el.resposta,
                                                        value: el.linha,
                                                    }))}
                                                    value={
                                                        dados.descricaoRespSel
                                                            ? {
                                                                  label: dados.descricaoRespSel,
                                                                  value: dados.linRespSel,
                                                              }
                                                            : ''
                                                    }
                                                    onChange={event => {
                                                        guardarRespostaSelecao(event?.value, event?.label, dados.id, dados.linhaId);
                                                    }}
                                                    noOptionsMessage={t('semopcoes')}
                                                    placeholder={t('selecioneOpcao')}
                                                    isDisabled={questionarioSelecionado.validado || !permissao.modificar}
                                                />
                                            </div>
                                        )}
                                        <div className="flex flex-col mt-2 ">
                                            <span className="text-gray-600 dark:text-gray-400">{t('observacoes')}:</span>
                                            <textarea
                                                id="message"
                                                rows="1"
                                                maxLength={250}
                                                value={dados.observacoes}
                                                onChange={e => {
                                                    dados.observacoes = e.target.value;
                                                    dados.alterada = true;
                                                    setPerguntas(perguntas.map(p => (p.id === dados.id ? dados : p)));
                                                }}
                                                className={`block p-2.5 py-2 w-64 xs:w-96 mt-2   text-xs text-gray-900  rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 bg-white dark:bg-gray-900 '}`}
                                                placeholder={t('escrevaDescricao')}
                                                disabled={questionarioSelecionado.validado || !permissao.modificar}></textarea>
                                        </div>
                                        {/* </div> */}
                                        {dados.limiteInicio != 0 ||
                                            (dados.limiteFim != 0 && (
                                                <div className="mt-4 mb-8">
                                                    <span className="text-gray-600 dark:text-gray-400">{t('nivelSatisfacao')}:</span>
                                                    <div className="relative">
                                                        <label htmlFor="price-range-input" className="sr-only">
                                                            Default range
                                                        </label>

                                                        <input
                                                            id="price-range-input"
                                                            type="range"
                                                            value={dados.valor}
                                                            min={dados.limiteInicio}
                                                            max={dados.limiteFim}
                                                            onChange={e => {
                                                                handleRangeChange(e, dados);
                                                            }}
                                                            style={{
                                                                '--thumb-color': '#1c64f2',
                                                            }}
                                                            className="w-64 h-2 bg-gray-300 ml-6 rounded-[8px] appearance-none cursor-pointer dark:bg-gray-700"
                                                            disabled={questionarioSelecionado.validado || !permissao.modificar}
                                                        />
                                                       
                                                        <style>
                                                            {`
                                                                #price-range-input::-webkit-slider-thumb {
                                                                    background-color: var(--thumb-color);
                                                                }
                                                            `}
                                                        </style>
                                                        <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-0 -bottom-6">{t('insatisfeito')} (0)</span>
                                                        <span className="text-lg text-gray-500 dark:text-gray-200 font-semibold absolute ml-2 start-36 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">
                                                            {dados.valor}
                                                        </span>
                                                        <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-56 -bottom-10 sm:-bottom-6">{t('muitoSatisfeito')} (10)</span>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                    <ToastContainer />
                </div>
            )}
        </>
    );
}

export default NovoQuestionario;
